/*
 * @Author: v-fmasoud@tableau.com
 * @Date: 2017-10-10 11:22:00
 * @Last Modified by: fmasoud@tableau.com
 * @Last Modified time: 2018-06-26 12:22:10
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { Language } from '../../common/Constants';

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-access-state-in-setstate */

class LanguageSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.getLanguageText(this.props.i18n.language),
      show: false,
    };
    this.touchsupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    this.setStateFromLanguage = this.setStateFromLanguage.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }

  componentDidMount() {
    this.props.i18n.on('languageChanged', this.setStateFromLanguage);
  }

  componentWillUnmount() {
    this.props.i18n.off('languageChanged', this.setStateFromLanguage);
  }

  setStateFromLanguage(language) {
    this.setState({ lang: this.getLanguageText(language) });
  }

  getLanguageText = (language) => {
    const lowercaseLanguage = language.toLowerCase();
    
    // Language mapping for reduced cognitive complexity
    const languageMap = {
      'en-us': Language.english.label,
      'en-gb': Language.english_uk.label,
      'fr-fr': Language.french.label,
      'fr-ca': Language.french_canada.label,
      'zh-cn': Language.chinese.label,
      'zh-tw': Language.chinese_taiwanese.label,
      'de': Language.deutch.label,
      'ja': Language.japanese.label,
      'ko': Language.korean.label,
      'pt': Language.portuguese.label,
      'es': Language.spanish.label,
      'it': Language.italian.label,
      'nl': Language.dutch.label,
      'sv': Language.swedish.label,
      'th': Language.thai.label
    };
    
    // Find matching language code
    for (const [code, label] of Object.entries(languageMap)) {
      if (lowercaseLanguage.includes(code)) {
        return label;
      }
    }
    
    // Default fallback
    return Language.english.label;
  };

  changeLanguage = lng => () => {
    this.props.i18n.changeLanguage(lng);
  };

  toggleShow() {
    this.setState(prevState => ({
      ...prevState,
      show: !prevState.show,
    }));
  }

  showMenu() {
    if (!this.touchsupport) {
      this.setState({ show: true });
    }
  }

  hideMenu() {
    if (!this.touchsupport) {
      this.setState({ show: false });
    }
  }

  render() {
    return (
      <div
        className="global-footer__language"
        role="presentation"
        onMouseEnter={this.showMenu}
        onMouseLeave={this.hideMenu}
        onClick={this.toggleShow}
      >
        <span className="selected">{this.state.lang}</span>
        {this.state.show && (
          <ul className="global-footer__language__options plain-list" style={{ whiteSpace: "nowrap" }}>
            <li className="de-DE first">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.deutch.code)}
              >
                {Language.deutch.label}
              </a>
            </li>
            <li className="en-GB">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.english_uk.code)}
              >
                {Language.english_uk.label}
              </a>
            </li>
            <li className="en-US">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink first"
                onClick={this.changeLanguage(Language.english.code)}
              >
                {Language.english.label}
              </a>
            </li>
            <li className="es-ES">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.spanish.code)}
              >
                {Language.spanish.label}
              </a>
            </li>
            <li className="fr-CA">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.french_canada.code)}
              >
                {Language.french_canada.label}
              </a>
            </li>
            <li className="fr-FR">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.french.code)}
              >
                {Language.french.label}
              </a>
            </li>
            <li className="it-IT">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.italian.code)}
              >
                {Language.italian.label}
              </a>
            </li>


            <li className="ja-JP">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.japanese.code)}
              >
                {Language.japanese.label}
              </a>
            </li>
            <li className="ko-KR">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.korean.code)}
              >
                {Language.korean.label}
              </a>
            </li>
            <li className="nl-NL">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink last"
                onClick={this.changeLanguage(Language.dutch.code)}
              >
                {Language.dutch.label}
              </a>
            </li>
            <li className="pt-BR">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.portuguese.code)}
              >
                {Language.portuguese.label}
              </a>
            </li>
            <li className="sv-SE">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.swedish.code)}
              >
                {Language.swedish.label}
              </a>
            </li>
            <li className="th-TH">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.thai.code)}
              >
                {Language.thai.label}
              </a>
            </li>
            <li className="zh-CN">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.chinese.code)}
              >
                {Language.chinese.label}
              </a>
            </li>
            <li className="zh-TW last">
              <a
                role="menuitem"
                tabIndex="-1"
                className="languageLink"
                onClick={this.changeLanguage(Language.chinese_taiwanese.code)}
              >
                {Language.chinese_taiwanese.label}
              </a>
            </li>
          </ul>
        )}
      </div>
    );
  }
}

/* eslint-enable jsx-a11y/anchor-is-valid */
/* eslint-enable react/no-access-state-in-setstate */

LanguageSelector.propTypes = {
  i18n: PropTypes.object.isRequired,
};

export default translate()(LanguageSelector);
